import { Directive } from "vue";

const focus: Directive = {
  mounted: (el) => el.focus()
}
export { focus }

const closable: Directive = {
  mounted: function mounted(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted: function unmounted(el) {
    document.removeEventListener("click", el.clickOutsideEvent);
  }
}
export { closable }


const autogrow: Directive = {
  mounted: function (element: HTMLElement) {

    // If used in a component library such as buefy, a wrapper will be used on the component so check if a child is the textarea
    const el = element.tagName.toLowerCase() === 'textarea' ? element : element.querySelector('textarea');

    el.setAttribute("rows", "1");

    const observe = function (element, event, handler) {
      element.addEventListener(event, handler, false);
    };

    const resize = () => {
      el.style.height = "auto";
      const padding = parseFloat(getComputedStyle(el).getPropertyValue("padding-top"));
      el.style.height = (el.scrollHeight + padding) + "px";
    };

    // 0-timeout to get the already changed el
    const delayedResize = () => {
      window.setTimeout(resize, 0);
    };

    // When the textarea is being shown / hidden
    const respondToVisibility = (element, callback) => {
      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) callback();
        });
      }, {
        root: document.documentElement
      }
      );

      intersectionObserver.observe(element);
    };

    respondToVisibility(el, resize);
    observe(el, "change", resize);
    observe(el, "cut", delayedResize);
    observe(el, "paste", delayedResize);
    observe(el, "drop", delayedResize);
    observe(el, "input", resize);
    observe(el, "focus", resize);

    resize();
  }
};


export { autogrow }



